import {
  forwardRef,
  Icon as ChakraIcon,
  type IconProps as ChakraIconProps,
  type ComponentWithAs,
} from '@chakra-ui/react-v2';

export type IconProps = ChakraIconProps & {
  size?: string | number;
  secondaryColor?: string;
};

export const Icon: ComponentWithAs<'svg', IconProps> = forwardRef<
  IconProps,
  'svg'
>((props, forwardedRef) => {
  const {
    width,
    height,
    boxSize,
    size,
    secondaryColor,
    __css: cssProp,
    ...rest
  } = props;

  // To support icons with mixed aspect ratios, set either
  // width or height, and let the icon drive the other dimension.
  //
  // Or use boxSize to set both at once, to fit icons into
  // a consistent box.
  const squareSize = boxSize ?? size;

  const __css = {
    ...cssProp,
    '--secondary-color': secondaryColor ?? 'rgba(0,0,0,0)',
  };

  const dimensions =
    squareSize != null
      ? { width: squareSize, height: squareSize }
      : {
          width: width ?? (height ? 'auto' : undefined),
          height: height ?? (width ? 'auto' : undefined),
        };

  return (
    <ChakraIcon ref={forwardedRef} __css={__css} {...dimensions} {...rest} />
  );
});

Icon.displayName = 'Icon';
